module.exports = __webpack_public_path__ + "img/solution6.786350db.png";